<h2 mat-dialog-title mat-dialog-draggable-title style="margin-bottom: 0.5rem !important;">
    {{'title.enterprise_update_group_customer' | translate}}
    <button type="button" class="close" aria-label="Close" (click)="onNoClick()">
        <span aria-hidden="true">&times;</span>
    </button>
</h2>
<mat-divider></mat-divider>
<form #f="ngForm">
    <div class="row mt-2">
        <div class="col-lg-12 d-flex justify-content-center">
            <mat-form-field class="w-100">
                <input #focusInput matInput type="text" required (focusout)="group.name = group.name.trim()"
                    [placeholder]="'enterprise_customer_management.lbl_group_customer_name' | translate"
                    name="groupName" [(ngModel)]="group.name" maxlength="255" [formControl]="groupNameControl"
                    autocomplete="off" (input)="isFormChanging = true" />
                <button mat-button *ngIf="group.name" type="button" matSuffix mat-icon-button aria-label="Clear"
                    (click)="group.name=''">
                    <mat-icon>close</mat-icon>
                </button>
                <mat-error *ngIf="groupNameControl.invalid">
                    <span class="text-error">
                        {{'validation.group_customer_required' | translate}}
                    </span>
                </mat-error>
            </mat-form-field>
        </div>
        <div class="col-lg-12 d-flex justify-content-center">
            <mat-form-field class="w-100">
                <textarea #focusInput matInput type="text" (focusout)="group.description = group.description.trim()"
                    [placeholder]="'enterprise_customer_management.lbl_group_customer_description' | translate"
                    name="description" [(ngModel)]="group.description" maxlength="255" (input)="isFormChanging = true"
                    autocomplete="off"></textarea>
                <button mat-button *ngIf="group.description" type="button" matSuffix mat-icon-button aria-label="Clear"
                    (click)="group.description=''; isFormChanging = true">
                    <mat-icon>close</mat-icon>
                </button>
            </mat-form-field>
        </div>
    </div>
</form>

<div mat-dialog-actions class="justify-content-center">

    <!--build icon, set default cancel-->
    <button mat-stroked-button color="primary" type="button" (click)="onNoClick()" cdkFocusInitial appTrackEvent="w.btn.dsnhomkh.cap_nhat.huy_bo">
        <mat-icon class="mr-0">cancel</mat-icon>{{'button.cancel' | translate}}
    </button>
    <button [disabled]="!isFormChanging" class="ml-2" mat-raised-button color="primary" (click)="onSave()" appTrackEvent="w.btn.dsnhomkh.cap_nhat.cap_nhat">
        <mat-icon class="mr-0">save</mat-icon>{{'button.update' | translate}}
    </button>
</div>
